import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import { CaretLeft, CircleNotch } from "@phosphor-icons/react";
import { Button } from "app/components";

import TicketCategory from "./ticketCategory";
import useLoginModal from "../../login/useLoginModal";
import { formatDate } from "../../../utils/formatDate";
import { getPrimaryEventById } from "../api";
import "./style";

const AddCategory = (props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const loginModal = useLoginModal();

  const { userData } = useSelector((state) => state.app);
  const { primaryEventData, selectedCategory } = useSelector(
    (state) => state.primaryBuyerFlow
  );

  const { smp_detail_entity_set: catt = [] } = primaryEventData || {};

  const [activeCategory, setActiveCategory] = useState(null);
  const [selectedTickets, setSelectedTickets] = useState({});
  const [loading, setLoading] = useState(null);

  const handleNext = () => {

    const category = catt.find((category) => category.id === activeCategory);
    const price = category.is_paid ? Number(category.price) : 0;
    const count = selectedTickets[activeCategory] || 0;
    const totalPrice = price * count;

    const categoryInfo = {
      ...category,
      id: category.id,
      name: category.option_value_1,
      count,
      totalPrice,
      ref_id: category.ref_id,
    };

    dispatch({
      type: "SELECTED_CATEGORY:SET",
      data: categoryInfo,
    });

    navigate(window.innerWidth < 650 ? "/event/attendees" : "/event/checkout", {
      state: { id: location?.state?.id },
    });
  };

  const handleBack = () => {
    navigate(-1);
  };

  const handleProceed = () => {
    if (!userData?.email) {
      loginModal.onOpen();
      loginModal.callback.current = () => {
        handleNext()
      };
    }else{
      handleNext();
    }
  }

  const handleTicketChange = (id, count) => {
    const updatedTickets = {};

    catt.forEach((category) => {
      if (category.id === id) {
        updatedTickets[category.id] = count;
      } else {
        updatedTickets[category.id] = 0;
      }
    });

    dispatch({
      type: "ATTENDEES_DETAILS:SET",
      data: [],
    });
    setSelectedTickets(updatedTickets);
    setActiveCategory(id);
  };

 useEffect(() => {
   window.scrollTo(0, 0);
   setLoading(true);

   getPrimaryEventById(location?.state?.id, (data) => {
     if (data.payload) {
       dispatch({
         type: "PRIMARY_EVENT_DATA:SET",
         data: { ...data?.payload, id: data?._id || location?.state?.id, smp_id: data?.payload?.id, organiser_dtls: data?.organiser },
       });

       if (selectedCategory) {
         setActiveCategory(selectedCategory?.id);
         setSelectedTickets({ [selectedCategory?.id]: selectedCategory?.count });
       }
     }
     setLoading(false);
   });
 }, [location?.state?.id, selectedCategory]);


  const total = Object.values(selectedTickets).reduce(
    (sum, count) => sum + count,
    0
  ); 
  const totalTickets = isNaN(total) ? 0 : total;

  const totalPrice = catt.reduce((total, category) => {
    const ticketCount = selectedTickets[category.id] || 0;
    if (category.is_paid) {
      return total + ticketCount * category.price;
    }
    return total;
  }, 0);

  if (loading) {
    return (
      <div className="flex flex-col flex-1 justify-center items-center h-full w-full">
        <CircleNotch
          className="loader-icon"
          size={50}
          color="#FF2459"
        />
      </div>
    );
  }

  return (
    <div className="mt-[70px] md:mt-[100px] hgt md:overflow-y-hidden md:flex md:justify-center md:pt-7 md:bg-grey-5 md:relative">
      <div
        className="p-6 flex flex-col gap-9 h-full relative bg-white ove
        md:w-[540px] md:rounded-[20px] md:sha-2 md:static md:pb-[120px]"
      >
        <div className="flex gap-4">
          <div className="p-[7px] sha-1" onClick={handleBack}>
            <CaretLeft size={20.571} />
          </div>
          <div className="flex flex-col gap-[2px]">
            <h1 className="heading-16">{primaryEventData?.name}</h1>
            <p className="label-14 text-grey-70">
              {formatDate(primaryEventData?.start_date)}
            </p>
          </div>
        </div>

        <div className="flex flex-col gap-6 hgt-2 pb-5 md:h-[100%] overflow-y-scroll">
          {catt?.filter(c => c.is_active).map((category, index) => (
            <React.Fragment key={category.id}>
              <TicketCategory
                id={category.id}
                category={category}
                activeCategory={activeCategory}
                setActiveCategory={setActiveCategory}
                isAccordionOpen={activeCategory === category.id}
                onTicketChange={handleTicketChange}
                selectedCount={selectedTickets[category.id] || 0}
                availableQuantity={category?.available_quantity}
              />
              {index < catt.length - 1 && <hr />}
            </React.Fragment>
          ))}
        </div>

        <div
          className="fixed bottom-0 left-0 w-full mt-auto pt-5 pb-6 px-6 flex gap-3 items-center border-t-[#FFF2F2] border-t border-solid bg-[#FDFDFD]
          md:gap-16 md:justify-center"
        >
          <div className="wdh flex gap-3 md:gap-16 items-center">
            {totalTickets > 0 && (
              <div className="w-[100px]">
                <div className="heading-16 w-full">₹ {totalPrice}</div>
                <div className="label-14 text-grey-70">
                  {totalTickets} {totalTickets === 1 ? "ticket" : "tickets"}
                </div>
              </div>
            )}
            <Button
              className="w-full"
              disabled={totalTickets === 0}
              onClick={handleProceed}
            >
              Proceed
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddCategory;
